import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Cookies from "js-cookie";

const COOKIE_NAME = "device_id";
const COOKIE_MAX_AGE = 365;

let fingerprintPromise: Promise<string> | null = null;

function loadFingerprint(): Promise<string> {
  return FingerprintJS.load()
    .then((fp) => fp.get())
    .then((result) => {
      Cookies.set(COOKIE_NAME, result.visitorId, {
        expires: COOKIE_MAX_AGE,
        path: "/",
        sameSite: "lax",
        secure: window.location.protocol === "https:",
      });
      return result.visitorId;
    });
}

export async function getDeviceId(): Promise<string> {
  const cached = Cookies.get(COOKIE_NAME);
  if (cached) return cached;

  if (!fingerprintPromise) {
    fingerprintPromise = loadFingerprint();
  }

  return fingerprintPromise;
}

export function getDeviceIdSync(): string | undefined {
  return Cookies.get(COOKIE_NAME);
}
